import React ,{useContext} from 'react'
import {HeroContext} from './App'
export default function SideNav() {
    const {handleHeroSelect,handleShowCart}=useContext(HeroContext)
    return (
        <div className="sideNav">
            <div 
            className="batman"
            onClick={()=>{
                handleHeroSelect('batman')
                handleShowCart(false)
            }}
            />
            <div 
            className="superman"
            onClick={()=>{
                handleShowCart(false)
                handleHeroSelect('superman')}}
            />
            <div 
            className="greenlantern"
            onClick={()=>{
                handleShowCart(false)
                handleHeroSelect('greenlantern')
            }}
            />
        </div>
    )
}
